import { _callAuthenticatedAPI } from '../apiCaller';

export function getTask(taskId: string): Promise<any> {
    const endpointUrl = `backend/api/v1/task/${taskId}`;
    return _callAuthenticatedAPI(endpointUrl);
}

export function getTaskActivities(taskId: string): Promise<any> {
    const endpointUrl = `backend/api/v1/task/${taskId}/activities`;
    return _callAuthenticatedAPI(endpointUrl);
}

export function getTaskLlmInfo(taskId: string): Promise<any> {
    const endpointUrl = `backend/api/v1/task/${taskId}/llm-info`;
    return _callAuthenticatedAPI(endpointUrl);
}
